import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TestimonialProps } from "../types/testimonials";

export const useWatchTestimonials = (): TestimonialProps[] => {
    const { t } = useTranslation("watchTestimonials");

    // Get testimonials from current language
    const testimonials = t("testimonials", { returnObjects: true }) as Array<{
        quote: string;
        name: string;
        role: string;
    }>;

    // Safety check
    if (!Array.isArray(testimonials)) {
        return watchTestimonials;
    }

    // Map to TestimonialProps format
    return testimonials.map((item, index) => ({
        quote: item.quote,
        name: item.name,
        role: item.role,
        avatar: `/public/media/landing/avatar${index + 1}.png`,
        rating: index === 2 || index === 4 ? 4 : 5,
        index,
    }));
};

// Export static data for backward compatibility (optional)
export const watchTestimonials: TestimonialProps[] = [
    {
        quote: "ساعت هوشمند دلبند برای فرزندم عالی است! همیشه می‌دانم کجاست و با قابلیت موقعیت مکانی، خیالم راحت است.",
        name: "مادر نگران",
        role: "والد",
        avatar: "/public/media/landing/avatar1.png",
        rating: 5,
        index: 0,
    },
    {
        quote: "هشدار خروج از محدوده واقعاً کاربردی است. وقتی فرزندم از منطقه امن خارج می‌شود، بلافاصله مطلع می‌شوم.",
        name: "پدر مسئولیت‌پذیر",
        role: "والد",
        avatar: "/public/media/landing/avatar2.png",
        rating: 5,
        index: 1,
    },
    {
        quote: "قابلیت اشتراک‌گذاری با خانواده به ما این امکان را می‌دهد که همه اعضای خانواده از موقعیت فرزندمان باخبر باشند.",
        name: "خانواده شاد",
        role: "والدین",
        avatar: "/public/media/landing/avatar3.png",
        rating: 4,
        index: 2,
    },
    {
        quote: "تماس اضطراری SOS یک ویژگی حیاتی است. فرزندم می‌تواند در مواقع خطر با یک دکمه با من تماس بگیرد.",
        name: "مادر دلسوز",
        role: "والد",
        avatar: "/public/media/landing/avatar4.png",
        rating: 5,
        index: 3,
    },
    {
        quote: "زمان‌بندی کلاس‌ها در ساعت هوشمند به فرزندم کمک می‌کند تا برنامه‌ریزی بهتری داشته باشد و هیچ کلاسی را از دست ندهد.",
        name: "پدر منظم",
        role: "والد",
        avatar: "/public/media/landing/avatar5.png",
        rating: 4,
        index: 4,
    },
    {
        quote: "این ساعت هوشمند به فرزندم احساس استقلال می‌دهد و در عین حال، من از امنیت او مطمئن هستم.",
        name: "مادر آگاه",
        role: "والد",
        avatar: "/public/media/landing/avatar6.png",
        rating: 5,
        index: 5,
    },
    {
        quote: "طراحی جذاب و رنگارنگ ساعت باعث شده فرزندم عاشق آن شود و همیشه آن را بپوشد.",
        name: "پدر خوش‌سلیقه",
        role: "والد",
        avatar: "/public/media/landing/avatar7.png",
        rating: 5,
        index: 6,
    },
];
